import axios from "axios";
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import { setPeopleGroupFilterIds } from './query';
import { changeSelectedPeople } from './select_list';
import { retrievePeople, setPersonTags } from './search';
import { toggleAlert } from './ui';

import TagsApi from 'bundles/tags/tags_api';

import taskApi from 'components/tasks/api';
import { bulkCreateLeads } from 'components/project/api';

import { post } from 'helpers/api';
import { formatDate } from 'helpers/formatters/date_time_formats';
import { map } from 'lodash';

export const ADD_GROUP = 'PEOPLE-ADD_GROUP';
export function addGroup(group) {
  return {
    group,
    type: ADD_GROUP
  };
}

export const CHANGE_GROUPS = 'PEOPLE-CHANGE_GROUPS';
export function changeGroups(groups) {
  return {
    groups,
    type: CHANGE_GROUPS
  };
}

export const END_DELETE_GROUPS = 'END_DELETE_GROUPS';
export function endDeleteGroups() {
  return { type: END_DELETE_GROUPS };
}

export const END_EDIT_GROUPS = 'PEOPLE-END_EDIT_GROUPS';
export function endEditGroups() {
  return { type: END_EDIT_GROUPS };
}

export const END_EMAIL_GROUP = 'PEOPLE-END_EMAIL_GROUP';
export function endEmailGroup() {
  return { type: END_EMAIL_GROUP };
}

export const END_BULK_TAGGING = 'END_BULK_TAGGING';
export function endBulkTagging() {
  return { type: END_BULK_TAGGING };
}

export const END_BULK_DELETE = 'END_BULK_DELETE';
export function endBulkDelete() {
  return { type: END_BULK_DELETE };
}

export const END_BULK_TASKS = 'END_BULK_TASKS';
export function endBulkTask() {
  return { type: END_BULK_TASKS };
}

export const END_NEW_CALL_LIST = 'END_NEW_CALL_LIST';
export function endNewCallList() {
  return { type: END_NEW_CALL_LIST };
}

export const END_ADD_LEADS_TO_PROJECTS = 'END_ADD_LEADS_TO_PROJECTS';
export function endAddLeadsToProjects() {
  return { type: END_ADD_LEADS_TO_PROJECTS };
}

export const START_BULK_DELETE = 'START_BULK_DELETE';
export function startBulkDelete() {
  return { type: START_BULK_DELETE };
}

export const START_BULK_TAGGING = 'START_BULK_TAGGING';
export function startBulkTagging() {
  return { type: START_BULK_TAGGING };
}

export const START_BULK_TASKS = 'START_BULK_TASKS';
export function startBulkTask() {
  return { type: START_BULK_TASKS };
}

export const START_NEW_CALL_LIST = 'START_NEW_CALL_LIST';
export function startNewCallList() {
  return { type: START_NEW_CALL_LIST };
}

export const START_ADD_LEADS_TO_PROJECTS = 'START_ADD_LEADS_TO_PROJECTS';
export function startAddLeadsToProjects() {
  return { type: START_ADD_LEADS_TO_PROJECTS };
}

export const START_DELETE_GROUPS = 'START_DELETE_GROUPS';
export function startDeleteGroups(groups) {
  return {
    groups,
    type: START_DELETE_GROUPS
  };
}

export const START_EDIT_GROUPS = 'PEOPLE-START_EDIT_GROUPS';
export function startEditGroups(groups) {
  return {
    groups,
    type: START_EDIT_GROUPS
  };
}

export const START_EMAIL_GROUP = 'PEOPLE-START_EMAIL_GROUP';
export function startEmailGroup(contactIds) {
  return (dispatch, getState) => {
    post(getState().paths.people.emails, { ids: contactIds }).then(({ emails }) => {
      dispatch({
        emails,
        type: START_EMAIL_GROUP
      });
    });
  };
}

export const SET_ACTIVITY = 'PEOPLE-SET_ACTIVITY';
export function setActivity(activity) {
  return {
    activity,
    type: SET_ACTIVITY
  };
}

export const SET_NOTES = 'PEOPLE-SET_NOTES';
export function setNotes(notes) {
  return {
    notes,
    type: SET_NOTES
  };
}

export const SET_TASKS = 'PEOPLE-SET_TASKS';
export function setTasks(tasks) {
  return {
    tasks,
    type: SET_TASKS
  };
}

export const SET_BULK_TAGS = 'PEOPLE-SET_BULK_TAGS';
export function setBulkTags(tags) {
  return { tags, type: SET_BULK_TAGS };
}

export function sendNotes(path) {
  return (dispatch, getState) => {
    return axios.patch(
      path,
      {
        contacts_person: {
          comments_attributes: {
            0: {
              body: getState().people.notes
            }
          }
        }
      }
    ).then(() => {
      dispatch(setNotes(""));
      dispatch(saveActivity(true));
    });
  };
}

export const SAVE_ACTIVITY = 'PEOPLE-SAVE_ACTIVITY';
export function saveActivity(saved) {
  return {
    saved,
    type: SAVE_ACTIVITY
  };
}

export function deleteGroups(groups) {
  return (dispatch) => {
    const requests = groups.map(group => axios.delete(group.url));
    return Promise.all(requests).then(() => {
      dispatch(endDeleteGroups());
      dispatch(retrieveGroups());
    });
  };
}

export function getTasks(assigneeId) {
  return (dispatch, getState) => {
    const path = getState().paths.tasks;
    return axios.get(
      path,
      {
        params: {
          "q[completed]": true,
          "q[task_associations_associated_model_id_eq]": assigneeId,
          "q[task_associations_associated_model_type_eq]": "Contacts::Person"
        }
      }
    ).then((response) => {
      const tasks = map(response.data.tasks, tasks => tasksFromApi(tasks.task));
      dispatch(setTasks(tasks));
    });
  };
}

export function sendTask(isCompleted, activity) {
  return () => {
    taskApi.addTask(
      {
        taskType: activity.taskType,
        completed: isCompleted,
        logged: isCompleted,
        title: activity.taskSummary,
        body: activity.taskDetails,
        assigneeId: activity.assigneeDatabaseMember.value,
        dueDate: activity.taskDate.toString(),
        associatedModels: associateToTask(activity.associatedModels)
      }
    );
  };
}

function associateToTask(associatedModels) {
  return associatedModels.map((model) => {
    return {
      associatedModelId: model.id,
      associatedModelType: model.modelType,
      _destroy: false
    };
  });
}

export function clearTasks() {
  return (dispatch) => {
    dispatch(setNotes(""));
    dispatch(saveActivity(false));
  };
}

export function addToGroup(group, ids) {
  return (dispatch) => {
    return axios.patch(
      group.url,
      {
        member_ids: ids
      }
    ).then(() => dispatch(retrieveGroups()));
  };
}

export function bulkDelete() {
  return (dispatch, getState) => {
    const deletePath = getState().paths.people.bulkDelete;
    const peopleIds = getState().selectList.selectedPersonIds;

    post(deletePath, { contactIds: peopleIds }).then(({ message, error }) => {
      dispatch(endBulkDelete());
      dispatch(retrievePeople());
      dispatch(toggleAlert(message, error));
      dispatch(changeSelectedPeople([]));
    });
  };
}

export function bulkTagging(tags, peopleIds) {
  return (dispatch, getState) => (
    axios.put(getState().paths.tags.bulkTagging, {
      tags: tags,
      people_ids: peopleIds,
    }).then((response) => {
      if (response.status == 200) {
        const text = peopleIds.length > 1 ? " Contacts were Tagged" : " Contact was Tagged";
        dispatch(toggleAlert(peopleIds.length + text, false));
      } else {
        const text = peopleIds.length > 1 ? " Contacts weren't Tagged" : " Contact was not Tagged";
        dispatch(toggleAlert(peopleIds.length + text, true));
      }
    }));
}

export function removeTag(tag, person) {
  const tagsPath = {
    tags: person.tagsPath
  };
  const api = new TagsApi(tagsPath);
  return dispatch => (
    api.deleteTag(tag).then((newTags) => {
      dispatch(setPersonTags(person.id, newTags));
    })
  );
}

export function addLeadsToProject(projectId, ids, status) {
  const leadData = {
    projects_lead_status_id: status.id,
    contact_ids: ids,
    contact_type: 'Contacts::Person'
  };
  return dispatch => (
    bulkCreateLeads(projectId, leadData).then((response) => {
      dispatch(toggleAlert(response.message, false));
    })
  );
}

export function addTag(tag, person) {
  const tagsPath = {
    tags: person.tagsPath
  };
  const api = new TagsApi(tagsPath);
  return dispatch => (
    api.saveTag(tag).then((newTags) => {
      dispatch(setPersonTags(person.id, newTags));
    })
  );
}

export function deleteFromGroup(group, ids) {
  return (dispatch) => {
    return axios.patch(
      group.deleteMembersUrl,
      {
        member_ids: ids
      }
    ).then(() => dispatch(retrieveGroups()));
  };
}

export function createGroup(group, ids) {
  return (dispatch, getState) => {
    const { id, ...groupAttributes } = snakecaseKeys(group);

    return axios.post(
      getState().paths.people.groups,
      {
        group: groupAttributes,
        member_ids: ids
      }
    ).then((response) => {
      dispatch(addGroup(camelcaseKeys(response.data.group)));
      dispatch(endEditGroups());
      dispatch(setPeopleGroupFilterIds([response.data.group.id]));
      dispatch(retrievePeople());
      return response.data.group;
    });
  };
}

export function updateGroups(groups) {
  return (dispatch) => {
    const requests = groups.map((group) => {
      const { url, ...groupAttributes } = snakecaseKeys(group);
      return axios.patch(url, { group: groupAttributes });
    });

    return Promise.all(requests).then(() => {
      dispatch(endEditGroups());
      dispatch(retrieveGroups());
    });
  };
}

export function newGroup() {
  return startEditGroups([{
    id: null,
    name: ''
  }]);
}

export function createBulkTask(task, ids) {
  return dispatch => (
    taskApi.bulkCreate(task, ids).then((result) => {
      dispatch(toggleAlert(result.message, false));
    }).catch((error) => {
      dispatch(toggleAlert(error.message, true));
    })
  );
}

export function retrieveGroups() {
  return (dispatch, getState) => (
    axios.get(getState().paths.people.groups).then(response => (
      dispatch(changeGroups(map(response.data.groups, group => camelcaseKeys(group))))
    ))
  );
}

function tasksFromApi(apiTask) {
  return {
    body: apiTask.body,
    completedAt: formatDate(apiTask.completedAt),
    id: apiTask.id,
    type: apiTask.task_type,
    title: apiTask.title
  };
}
